export default "__VITE_ASSET__d7f35d94__"